
/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
 export function handleTree(data, id, parentId, children) {
    let config = {
      id: id || 'id',
      parentId: parentId || 'parentId',
      childrenList: children || 'children'
    };
  
    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];
  
    for (let d of data) {
      let parentId = d[config.parentId];
      if (childrenListMap[parentId] == null) {
        childrenListMap[parentId] = [];
      }
      nodeIds[d[config.id]] = d;
      childrenListMap[parentId].push(d);
    }
  
    for (let d of data) {
      let parentId = d[config.parentId];
      if (nodeIds[parentId] == null) {
        tree.push(d);
      }
    }
  
    for (let t of tree) {
      adaptToChildrenList(t);
    }
  
    function adaptToChildrenList(o) {
      if (childrenListMap[o[config.id]] !== null) {
        o[config.childrenList] = childrenListMap[o[config.id]];
      }
      if (o[config.childrenList]) {
        for (let c of o[config.childrenList]) {
          adaptToChildrenList(c);
        }
      }
    }
    return tree;
  }

  //判断是否为手机端
  export function isMobile() {
    //console.log(navigator)
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
  }


  export function gotoMobile(that, murl, url){
    if (that.$store.state.mbrowser) {
      that.gotoUrl(murl)
    } else {
      that.gotoUrl(url)
    }
  }


//判断是否为数组的元素
export function inArray(str, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (str == arr[i]) {
        return true
      }
    }
    return false;
  }
  
  
  //判断是否为空
  export function isEmpty(obj) {
    if (obj === 'undefined' || obj === undefined || obj === "" || obj === null) {
      return true
    }
    else {
      return false;
    }
  }
  
  //返回随机数
  export function getRandom(m) {
    return Math.round(Math.random() * m);
  }
  
  //姓名中替换*
  export function setUserName(username) {
    if (username == "") {
      return ""
    }
    else {
      var len = username.length
      var firstName = username.slice(0, 1)
      var namestr = ""
      for (var i = 0; i < len; i++) {
        namestr += "*"
      }
      return firstName + namestr
    }
  }

  export function gotoUrlParams(url, id){
    this.$router.push({path: url + id}).catch(err => err);
  }
  
  //通用跳转方法
  export function gotoUrl(url, params, method) {
    if (isEmpty(url)) {
      this.$router.go(-1)
    }
    else {
      if (method == '_blank') {
        if(url.indexOf('http') != -1){
            window.open(url, '_blank');
        }
        else{
          let routeData = this.$router.resolve({ path: url, query: params });
          window.open(routeData.href, '_blank');
        }      
      }
      else {
        this.$router.push({ path: url, query: params }, (err)=>{
            console.log(err)
        });
      }
    }
  }
  
  //返回数据所有下标
  export function getArrIndexs(arr) {
    var temp = []
    for (var i = 0; i < arr.length; i++) {
      temp.push(i + "");
    }
    return temp;
  }
  
  //根据数组1的值，返回数组2的下标
  export function getTypeIndex(arr1, arr2) {
    var temp = []
    for (var i = 0; i < arr1.length; i++) {
      for (var j = 0; j < arr2.length; j++) {
        if (arr1[i] == arr2[j]) {
          temp.push(j)
        }
      }
    }
    return temp;
  }
  
  //根据数组1的下标，返回数组2的值
  export function getTypeName(arr1, arr2) {
    var temp = []
    for (var i = 0; i < arr1.length; i++) {
      for (var j = 0; j < arr2.length; j++) {
        if (arr1[i] == j) {
          temp.push(arr2[j])
        }
      }
    }
    return temp;
  }

  
//字符串转数组
export function strToArray(str, split, type) {
    if (this.isEmpty(str)) {
      return [];
    }
    var arr = []
    if (str.indexOf(split) != -1) {
      arr = str.split(split)
    }
    else {
      arr[0] = str
    }
    return arr;
  }

  
//删除数组元素
export function delArray(str, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == str) {
        arr.slice(i, 1)
      }
    }
  }
  
  //校验手机号
  export function phoneCheck(str) {
    if (str == '') {
      return false
    }
    else {
      //var reg = /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^\([0-9]{3,4}\)[0-9]{3,8}$)|(^0{0,1}1[0-9]{10}$)/
      var pattern = new RegExp("^1[3456789]\\d{9}$", 'i')
      return pattern.test(str)
    }
  }
  
  //返回学年列表
  export function getStudyYears(starNum, endNum) {
    if (isEmpty(starNum)) {
      starNum = 1
    }
    if (isEmpty(endNum)) {
      endNum = 2
    }
    var date = new Date()
    var y = date.getFullYear()
    var temp = []
    for (var i = 0; i < starNum; i++) {
      var j = i + 1
      temp.push(y + j + '')
    }
    temp.push(y + '')
    for (var m = 0; m < endNum; m++) {
      var k = m + 1
      temp.push(y - k + '')
    }
    return temp;
  }


// WEBPACK FOOTER //
// ./src/utils/function.js